import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { EMPTY, Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export type SearchContentType = 'POST' | 'BLOG' | 'EVENT';

export interface ISearchFilters {
  q?: string;         // free text — matched against title (and hashtags as fallback)
  hashtag?: string;    // exact hashtag match, no leading '#'
  type?: SearchContentType;  // omit to search posts + blogs + events together
}

@Injectable({ providedIn: 'root' })
export class SearchService {

  private http       = inject(HttpClient);
  private platformId = inject(PLATFORM_ID);
  private baseUrl    = `${environment.apiUrl}/search`;

  /**
   * Global search across posts, blogs and events (title text and/or exact hashtag).
   * Used by:
   *   - the header's global search dropdown (small, unfiltered preview)
   *   - the "All" page (full paginated, tab-filterable results)
   *   - <app-posts>/<app-blog>/<app-events> when given [searchQuery] / [searchHashtag]
   */
  search(page = 1, limit = 12, filters?: ISearchFilters): Observable<any> {
    if (!isPlatformBrowser(this.platformId)) return EMPTY;

    let params = new HttpParams()
      .set('page', page.toString())
      .set('limit', limit.toString());

    if (filters?.q) params = params.set('q', filters.q);
    if (filters?.hashtag) params = params.set('hashtag', filters.hashtag.replace(/^#+/, ''));
    if (filters?.type) params = params.set('type', filters.type);

    return this.http.get(`${this.baseUrl}`, { params });
  }
}
